export default __webpack_public_path__ + "static/media/123.f71ef630.png";